export const OPEN_INTEREST_SECTION = "OPEN_INTEREST_SECTION";
export const OPEN_INTEREST_SECTION_STREAM = "OPEN_INTEREST_SECTION_STREAM";
